module.exports = __webpack_public_path__ + "static/singleplayer-18f6053955fdb4e6d4a4a470f20199ab.gif";